import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { replace } from '../../services/router-utils';
import classNames from 'classnames';
import { loginMember } from '../../actions/login-member';
import styles from './login-page.scss';
import LoginScreen from '../../components/login-screen';
import { XSmall } from '../../components/icons';
import BackButton from '../back-button';
import forMobileOnly from '../../hoc/for-mobile-only';

const BackButtonMobile = forMobileOnly(BackButton);

const LoginPage = props =>
  <LoginScreen {...props}>
    <BackButtonMobile className={classNames(styles.closeButton, 'forum-icon-fill')}>
      <XSmall/>
    </BackButtonMobile>
  </LoginScreen>;

LoginPage.propTypes = {
  onLogin: PropTypes.func.isRequired,
  onLoginError: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLogin: member => {
    dispatch(loginMember(member)).then(() => dispatch(replace(ownProps.location.query.redirect || '/')));
  },
  onLoginError: () => {
    dispatch(replace('/'));
  },
});

export default connect(undefined, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./app/containers/login-page/login-page.js